function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function classNames() {
  var args = arguments;
  var classes = [];

  for (var i = 0; i < args.length; i++) {
    var arg = args[i];

    if (!arg) {
      continue;
    }

    if ('string' === typeof arg || 'number' === typeof arg) {
      classes.push(arg);
    } else if ('object' === _typeof(arg)) {
      for (var key in arg) {
        if (!arg.hasOwnProperty(key) || !arg[key]) {
          continue;
        }

        classes.push(key);
      }
    }
  }

  return classes.join(' ');
} // safely export classNames in case the script is included directly on a page


if (typeof module !== 'undefined' && module.exports) {
  module.exports = classNames;
}